export default __webpack_public_path__ + "static/media/logo_niko_beta.ca88b46c.png";